import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section className="relative bg-brand-dark overflow-hidden pt-6 pb-10 md:pt-12 md:pb-20 lg:pt-16 lg:pb-24" data-id="element-165">
      {/* Decorative background elements */}
      <div className="absolute top-1/4 -left-20 w-72 h-72 bg-brand-accent/10 rounded-full blur-[120px] pointer-events-none" data-id="element-166"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-brand-accent/10 rounded-full blur-[120px] pointer-events-none" data-id="element-167"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-169">
          {/* Eyebrow badge */}
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1,
          duration: 0.5
        }} className="inline-flex items-center gap-2 bg-brand-accent/10 border border-brand-accent/30 text-brand-accent rounded-full px-4 py-1.5 mb-6 backdrop-blur-sm" data-id="element-170">
            <SparklesIcon className="w-3.5 h-3.5" data-id="element-171" />
            <span className="text-xs md:text-sm font-bold uppercase tracking-wider" data-id="element-172">
              Protocolo Kinesiológico #1
            </span>
          </motion.div>

          {/* Title — stretched, compact vertically */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white leading-[1.1] tracking-[0.08em] mb-2 uppercase" data-id="element-173">
            Tu año de kinesiología
          </h1>
          <div className="relative inline-block mb-5 md:mb-6" data-id="element-174">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black leading-[1] tracking-[0.06em] italic uppercase" data-id="element-175">
              <span className="relative inline-block" data-id="element-176">
                <span className="relative z-10 bg-gradient-to-r from-brand-accent via-cyan-300 to-brand-accent bg-clip-text text-transparent" data-id="element-177">
                  resuelto
                </span>
                <motion.span initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                delay: 0.7,
                duration: 0.8,
                ease: 'easeOut'
              }} className="absolute -bottom-1 md:-bottom-2 left-0 right-0 h-1.5 md:h-2 bg-brand-accent rounded-full origin-left" data-id="element-178" />
              </span>
              <span className="text-brand-accent" data-id="element-179">.</span>
            </h1>
          </div>

          {/* Product mockup between title and subtitle */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative mx-auto w-full max-w-xs sm:max-w-sm md:max-w-md mb-6 md:mb-8" data-id="element-180">
            <div className="absolute inset-0 bg-brand-accent/25 blur-[100px] rounded-full transform scale-75 z-0" data-id="element-181"></div>
            <motion.img src="https://cdn.magicpatterns.com/uploads/2kL6kZSrbYV6wX7PckBBEG/Untitled_design.png" alt="Megapack Columna Activa" className="relative z-10 w-full h-auto drop-shadow-2xl" animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-182" />
          </motion.div>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-slate-300 mb-6 md:mb-8 max-w-2xl mx-auto font-medium leading-relaxed" data-id="element-183">
            En 30 días notás la diferencia. En 90, tu postura cambia. El
            protocolo kinesiológico completo para corregir tu columna desde
            casa.
          </p>

          {/* CTA */}
          <div className="flex justify-center mb-6" data-id="element-184">
            <Button size="xl" onClick={() => document.getElementById('pricing')?.scrollIntoView()} data-id="element-185">
              QUIERO EL MEGAPACK AHORA
            </Button>
          </div>

          {/* Garantía */}
          <div className="flex items-center justify-center gap-2 text-slate-400 text-sm mb-5" data-id="element-186">
            <ShieldCheckIcon className="w-5 h-5 text-brand-accent" data-id="element-187" />
            <span data-id="element-188">
              Garantía 30 días. Si no notás cambios, te devolvemos el dinero.
            </span>
          </div>

          {/* Stars + social proof */}
          <div className="inline-flex items-center gap-2 bg-slate-800/50 rounded-full px-4 py-2 border border-slate-700" data-id="element-189">
            <div className="flex text-yellow-400" data-id="element-190">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-191" />)}
            </div>
            <span className="text-slate-300 text-xs md:text-sm font-medium" data-id="element-192">
              4.9 — +1.200 personas ya corrigieron su columna
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}